import { Button, Icon } from "@screencloud/screencloud-ui-components";
import DefaultHeader from "src/components/Header";
import { useAppContext } from "src/hooks/useAppContext";

type Props = {
  title: string;
  onBackButtonClick?: () => void;
  isShowBackButton?: boolean;
};

export const Header = ({
  title,
  onBackButtonClick = () => {},
  isShowBackButton = true,
}: Props) => {
  const context = useAppContext();

  const getTestIdFromTitle = (title: string): string =>
    (title.includes(" ") ? title.replace(" ", "-") : title).toLowerCase();

  return (
    <DefaultHeader
      className="header"
      data-testid={getTestIdFromTitle(title)}
      isShowBackButton={isShowBackButton}
    >
      <div className="wrapper detail">
        <div className="column-back">
          <Button
            data-testid={`${getTestIdFromTitle(title)}-back-button`}
            className="back"
            basic
            onClick={onBackButtonClick}
            title={context.intl.formatMessage({
              defaultMessage: "Back to previous page",
              id: "common.text.back_to_previous_page",
            })}
          >
            <Icon data-testid="back-arrow" name="arrow-left" />
          </Button>
        </div>
        <div
          className="column-title"
          data-testid={`${getTestIdFromTitle(title)}-title`}
        >
          <h1>{title}</h1>
        </div>
      </div>
    </DefaultHeader>
  );
};
